<template>
  <div>
    <my-table
      :data="data"
      :loading="loading"
      :headers="headers"
      :query="query"
      @delete="handleDelete"
      @search="handleSearch"
      @refresh="handleRefresh"
      @change-page="handleChangePage"
      @change-limit="handleChangeLimit"
    />
  </div>
</template>
<script>
import * as _ from 'lodash'
import listData from '../../utils/listData'
import listMethods from '../../utils/listMethods'
export default {
  data () {
    return {
      ...listData,
      listApiUrl: '/users',
      headers: [{
        name: 'lastName',
        caption: 'Овог'
      }, {
        name: 'firstName',
        caption: 'Нэр'
      }, {
        name: 'username',
        caption: 'Нэвтрэх нэр'
      }, {
        name: 'email',
        caption: 'И-Мейл хаяг',
        width: '140'
      }, {
        name: 'createdAt',
        caption: 'Бүртгэсэн огноо',
        type: 'Date',
        width: '90'
      }],
      query: { page: 1, limit: 15, sort: [], search: [] }
    }
  },
  beforeMount () {
    this.getList()
  },
  beforeUnmount () {
    this.handleCancelToken()
  },
  methods: {
    ...listMethods,
    async handleDelete (id) {
      try {
        await this.showConfirm({ message: 'Та тухайн бүртгэлийг устгахдаа итгэлтэй байна уу?' })
        await this.axios.delete(`/users/${id}`)
        _.pull(this.data[0], { id })
        this.data[1]--
        this.showToast('Амжилттай устгалаа.')
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
